import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/system";
import { colors } from "../config/colors";
import {
  DISPLAY_FLEX,
  MAX_WIDTH,
  FLEX_ALIGN_START,
  TEXT_ALIGN_LEFT,
} from "../config/styles";
import { SuccessLogo, WarningLogo, InfoIconLogo } from "../assets/icons";
import { Typography } from "@mui/material";

const CardStatusStyled = styled("div")({
  display: DISPLAY_FLEX,
  alignItems: FLEX_ALIGN_START,
  padding: "16px",
  gap: "12px",
  backgroundColor: colors.background,
  borderRadius: "8px",
  width: MAX_WIDTH,
  margin: "16px 0px",
});

export const CARD_STATUS_TYPE = {
  SUCCESS: "success",
  ERROR: "error",
  PROGRESS: "progress",
};

export const CardStatus = ({
  title = "",
  desc = "",
  type = CARD_STATUS_TYPE.SUCCESS,
}) => {
  return (
    <CardStatusStyled>
      {type === CARD_STATUS_TYPE.SUCCESS && <SuccessLogo />}
      {type === CARD_STATUS_TYPE.ERROR && <WarningLogo />}
      {type === CARD_STATUS_TYPE.PROGRESS && <InfoIconLogo />}
      <div
        className="d-flex flex-column"
        style={{ backgroundColor: colors.background }}
      >
        <Typography
          variant="subtitle2"
          sx={{ color: colors.custom, textAlign: TEXT_ALIGN_LEFT }}
        >
          {title}
        </Typography>
        <Typography
          variant="h4"
          sx={{ textAlign: TEXT_ALIGN_LEFT, marginTop: 1 }}
        >
          {desc}
        </Typography>
      </div>
    </CardStatusStyled>
  );
};

CardStatus.propTypes = {
  title: PropTypes.string,
  desc: PropTypes.string,
  type: PropTypes.oneOf(Object.values(CARD_STATUS_TYPE)),
};
